import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ReviewPage from "../pages/review/page";
import ShippingCostPage from "../pages/shipping-cost/page";
import CouponPage from "../pages/coupon/page";
import WarehousePage from "../pages/warehouse/page";
import IsLegitPage from "../pages/is-legit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-review",
    element: <ReviewPage />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <ShippingCostPage />,
  },
  {
    path: "/sugargoo-coupon",
    element: <CouponPage />,
  },
  {
    path: "/sugargoo-warehouse",
    element: <WarehousePage />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <IsLegitPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;